import ApiService from '../api.service'

import { Abono } from './abono'
import { Afastamento } from './afastamentos'
import { CompensacaoManual } from './compensacao-manual'
import { DescontoDSRFuncionario } from './dsr'
import { FaltaCadastrada } from './faltas-cadastradas'
import { CompensacaoFeriado } from './feriados'
import { FeriadosCliente } from './feriados-cliente'
import { Registro } from './registros'
import { Sobreaviso } from './sobreaviso'
import { TrocaDiaTrabalho } from './troca-horarios'

export interface JornadaDiaria {
    id: number
    nome: string
    empresaId: number
    dia: string
    registros: Registro[]
    abono?: Abono
    afastamento?: Afastamento
    compensacao?: CompensacaoFeriado
    compensacaoManual?: CompensacaoManual
    sobreaviso?: Sobreaviso
    faltaCadastrada?: FaltaCadastrada
    descontoDsr?: DescontoDSRFuncionario
    folga?: any
    trocaDiaTrabalho?: TrocaDiaTrabalho
    feriado?: FeriadosCliente
}

type JornadaDiariaQuery = {
    empresaId: number
    dia: string
}

type JornadaDiariaQueryCentroCusto = JornadaDiariaQuery & {
    centroCustoId: number
    localId?: never
}

type JornadaDiariaQueryLocal = JornadaDiariaQuery & {
    localId: number
    centroCustoId?: never
}

export type JornadaDiariaQueryXor =
    | JornadaDiariaQuery
    | JornadaDiariaQueryCentroCusto
    | JornadaDiariaQueryLocal

export type JornadaMensal = Omit<JornadaDiaria, 'id' | 'nome' | 'empresaId'>
type JornadaMensalQuery =
    | {
          funcionarioId: number
          organizar?: boolean
          competencia: string
      }
    | {
          funcionarioId: number
          organizar?: boolean
          dataInicial: string
          dataFinal: string
      }

type JornadaMensalQueryCentroCusto = JornadaMensalQuery & {
    centroCustoId: number
    localId?: never
}

type JornadaMensalQueryLocal = JornadaMensalQuery & {
    localId: number
    centroCustoId?: never
}

export type JornadaMensalQueryXor =
    | JornadaMensalQuery
    | JornadaMensalQueryCentroCusto
    | JornadaMensalQueryLocal

export const jornada = {
    mensal: new ApiService<null, JornadaMensal, JornadaMensalQueryXor>(
        'jornada',
    ),
    diaria: new ApiService<null, JornadaDiaria, JornadaDiariaQueryXor>(
        'jornada',
    ),
}
